import { Box, Typography } from '@mui/material'
import React from 'react'
import { Motion } from '../../Motion'
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import { fontLink, fullCenter } from '../../../base';
import { Txt } from '../../../Routes/Localized';
import LangLink from '../../../Localization/LangLink';

export default function FindVin({ sx = {}, sxText = {}, sxIcon = {}, text, onClick, headerView = false, to = "find_vin" }) {
    const textFinal = text || <Txt id={"21015"} />;
    return (
        <Motion scale={1.01} style={{ width: '100%' }}>
            <Box
                component={onClick ? Box : LangLink}
                to={onClick ? undefined : to}
                onClick={() => {
                    if (onClick) {
                        onClick();
                    }
                }}
                sx={{
                    ...fullCenter,
                    bgcolor: 'transparent', border: `1px solid white`, borderRadius: '50px', minHeight: '32px', width: '100%',
                    mt: '12px', cursor: 'pointer', textDecoration: 'none',
                    ...sx
                }}
            >
                <Typography sx={{
                    fontFamily: 'inter', fontWeight: 600, ...fontLink,
                    color: `white`, textAlign: 'left', ml: '30px', py: '2px',
                    ...sxText,
                }}>
                    {textFinal}
                </Typography>
                {!headerView && <ArrowForwardRoundedIcon sx={{ color: 'white', width: '16px', height: '16px', mx: '16px', ...sxIcon }} />}
            </Box>
        </Motion>
    )
}
